import React from 'react'
import { useParams } from 'react-router-dom'
import { Row } from 'antd'
import moment from 'moment'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'

const WeightTracking = () => {
    const { id } = useParams()
    return (
        <>
            <div>
                <Heading>Weight Tracking</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Pet_Weight_tracking.getAll,
                            extraQuery: {
                                petId: id
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `PW${data?.id.toString().padStart(7, "0")}`,
                                        date: moment(data?.date).format("DD MMM YYYY"),
                                        isSprayed: (data?.pet?.gender === 'female') ? (data?.isSprayed ? 'Yes' : 'No') : '-',
                                        isNeutered: (data?.pet?.gender === 'male') ? (data?.isNeutered ? 'Yes' : 'No') : '-',

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.PETS_WEIGHT_TRACKING,
                        }}
                        isSearch={true}

                    />
                </Row>

            </div>
        </>
    )
}

export default WeightTracking